export default new class {
    async update(data) {
        await axios.post(
            'cockpit/7f-forecast',
            data,
        );
    }
};
